import { createFileRoute } from "@tanstack/react-router";
import { TripDetailPage } from "../../components/participant/transport-trip-page";

/** `/me/transport/:tripKey` — one of the participant's own trips (the list card's opaque key; the API answers 404 for a trip they do not ride). Not nested in the list page. */
export const Route = createFileRoute("/_app/me/transport_/$tripKey")({
	component: function TripRoute() {
		const { tripKey } = Route.useParams();
		return <TripDetailPage tripKey={tripKey} />;
	},
});
